import { render } from "./EditChodanCoin.vue?vue&type=template&id=30ef204d&scoped=true"
import script from "./EditChodanCoin.vue?vue&type=script&lang=js"
export * from "./EditChodanCoin.vue?vue&type=script&lang=js"

import "./EditChodanCoin.vue?vue&type=style&index=0&id=30ef204d&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ef204d"]])

export default __exports__